export default __webpack_public_path__ + "1442d64f58485ef633b929bce491832f.jpg";